import React, { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// components
import { FaoBuilderContext } from "context/FaoBuilderContext";

// creating a separate component for this so we can display policy id or other info across all components if needed
function FaoBuilderHeader({ modelName, modelId }) {
  const { modelConfig, refreshStatus, refreshDispatch } =
    useContext(FaoBuilderContext);
  const location = useLocation();

  useEffect(() => {
    const fetchRefresh = async () => {
      if (!modelConfig?.id) {
        return;
      }
      const activeRefresh = refreshStatus[modelConfig.id]?.isRefreshing;
      if (activeRefresh) {
        const toastId = toast.loading("Refreshing dataset...", {
          autoClose: false,
        });
        refreshDispatch({
          type: "refresh_found",
          modelId: modelConfig.id,
          toastId,
        });
      }
    };
    fetchRefresh();
  }, [location.pathname]);
  return (
    <div className="mb-8">
      <h1 className="text-2xl font-bold text-blue-03">
        Currently Editing: {modelName}
      </h1>
      <span className="rounded bg-gray-100 px-2 py-1 text-sm text-gray-500">
        {modelId}
      </span>
    </div>
  );
}
export default FaoBuilderHeader;
